import { useState, useEffect, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import api from "@/lib/api";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import HeutePage from "@/pages/HeutePage";
import HistoriePage from "@/pages/HistoriePage";
import StatistikenPage from "@/pages/StatistikenPage";
import EinstellungenPage from "@/pages/EinstellungenPage";
import VertriebPage from "@/pages/VertriebPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const [authState, setAuthState] = useState("loading");

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        await api.get("/auth/verify");
        setAuthState("authenticated");
        return;
      } catch {
        localStorage.removeItem("token");
      }
    }
    try {
      const res = await api.get("/auth/status");
      setAuthState(res.data.has_password ? "login" : "setup");
    } catch {
      setAuthState("login");
    }
  }, []);

  useEffect(() => {
    document.documentElement.classList.add("dark");
    checkAuth();
  }, [checkAuth]);

  const handleAuth = (token) => {
    localStorage.setItem("token", token);
    setAuthState("authenticated");
  };

  if (authState === "loading") {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-zinc-500 font-mono text-sm">Laden...</div>
      </div>
    );
  }

  if (authState === "setup" || authState === "login") {
    return (
      <>
        <LoginPage mode={authState} onAuth={handleAuth} />
        <Toaster position="top-center" />
      </>
    );
  }

  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/heute" element={<HeutePage />} />
          <Route path="/heute/:entryDate" element={<HeutePage />} />
          <Route path="/vertrieb" element={<VertriebPage />} />
          <Route path="/historie" element={<HistoriePage />} />
          <Route path="/statistiken" element={<StatistikenPage />} />
          <Route path="/einstellungen" element={<EinstellungenPage />} />
        </Routes>
      </Layout>
      <Toaster position="top-center" />
    </BrowserRouter>
  );
}

export default App;
